module.exports = __webpack_public_path__ + "static/media/logo-bol.36f2406b.png";